// extracted by mini-css-extract-plugin
export default {"border":"IFrame_border__nAXxB"};